<template>
  <span class="badge" :class="value">
    {{ value | transformData(config) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: String,
      config: Array,
    },
  }
</script>
<style scoped></style>
